import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { useLanguage } from '../i18n';
import { getPortalPageCopy } from '../portalPageCopy';

const FeatureUnavailable = () => {
  const { lang } = useLanguage();
  const copy = getPortalPageCopy(lang, 'shared');
  return (
  <Box
    role="status"
    maxW="2xl"
    m={{ base: 4, md: 8 }}
    p={{ base: 5, md: 6 }}
    borderWidth="1px"
    borderColor="blue.200"
    borderRadius="lg"
    bg="blue.50"
  >
    <Heading size="md" color="gray.900">{copy.featureUnavailable}</Heading>
    <Text mt={2} color="gray.700">
      {copy.featureUnavailableDetail}
    </Text>
  </Box>
  );
};

export default FeatureUnavailable;
